module.exports = __webpack_public_path__ + "src/img/clockbeats-orchestra/feature-small.437ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clockbeats-orchestra/feature-small.jpg
// module id = 95
// module chunks = 0